import styled, { css } from 'styled-components';

import type { ProductType } from '@xing-com/crate-common-graphql-types';
import { Column, Row } from '@xing-com/xing-grid';

import { Navigation } from './navigation';

interface NavigationRowProps {
  disabled: boolean;
  className?: string;
  product: ProductType;
}

export function NavigationRow({
  disabled,
  className = '',
  product,
}: NavigationRowProps): JSX.Element {
  return (
    <StyledRow className={className} disabled={disabled}>
      <Column size={12}>
        <Navigation product={product} />
      </Column>
    </StyledRow>
  );
}

const StyledRow = styled(Row)<{ disabled: boolean }>`
  display: flex;
  flex-grow: 1;
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `};
`;
